export const ISSUE_EMPLOYEE_ASSET = "ISSUE_EMPLOYEE_ASSET";
export const FETCH_EMPLOYEE_ASSETS = "FETCH_EMPLOYEE_ASSETS";
export const FETCH_EMPLOYEE_ASSET = "FETCH_EMPLOYEE_ASSET";
export const EDIT_EMPLOYEE_ASSET = "EDIT_EMPLOYEE_ASSET";
export const DELETE_EMPLOYEE_ASSET = "DELETE_EMPLOYEE_ASSET";
